<template>
  <div class="conf">
    <div class="conf-preview">
      <preview/>
    </div>
    <div class="conf-parts" ref="scroller">
      <div class="conf-parts__list" ref="scrollerContent">
        <part v-for="part in parts" :key="part.id" :part="part"/>
      </div>
      <button class="conf-parts__next" :disabled="disabledNext" @click="next()"></button>
      <button class="conf-parts__prev" :disabled="disabledPrev" @click="prev()"></button>
    </div>
    <dimensions/>
    <setup/>
    <nav class="conf-nav">
      <span class="conf-nav__item" @click="resetConfiguration()">
        <img class="conf-nav__ico-reset" src="/static/svg/reset.svg"> Reset
      </span>
      <span class="conf-nav__item" @click="submitSetup()">
        <img class="conf-nav__ico-mail" src="/static/svg/mail.svg"> Email setup
      </span>
      <span class="conf-nav__item" v-on:click.prevent="toggleSetup()">
        <img class="conf-nav__ico-setup" src="/static/svg/setup.svg">
        <span v-if="setupVisible">Close setup</span>
        <span v-else>Show setup</span>
      </span>
    </nav>
  </div>
</template>

<script>
// eslint-disable-next-line
import anime from 'animejs/lib/anime.es.js';
import { mapState, mapActions } from 'vuex';

import Part from '@/components/Part';
import Preview from '@/components/Preview';
import Setup from '@/components/Setup';
import Dimensions from '@/components/Dimensions';

export default {
  components: { Part, Preview, Setup, Dimensions },
  data() {
    return {
      disabledNext: false,
      disabledPrev: false,
    };
  },
  mounted() {
    this.updateNav();
  },
  computed: {
    ...mapState(['parts', 'setupVisible', 'configuration']),
  },
  methods: {
    ...mapActions(['resetConfiguration', 'toggleSetup']),
    submitSetup() {
      this.$router.push({ name: 'Mail' });
    },
    updateNav() {
      setTimeout(() => {
        const scroller = this.$refs.scroller;
        this.disabledNext = scroller.scrollWidth === (scroller.scrollLeft + scroller.clientWidth);
        this.disabledPrev = scroller.scrollLeft === 0;
      }, 100);
    },
    scrollParts(value) {
      anime({
        targets: this.$refs.scroller,
        scrollLeft: this.$refs.scroller.scrollLeft + value,
        duration: 150,
        easing: 'easeInOutQuad',
        complete: this.updateNav(),
      });
    },
    next() {
      this.scrollParts(200);
    },
    prev() {
      this.scrollParts(-200);
    },
  },
  watch: {
    configuration() {
      this.updateNav();
    },
  },
};
</script>

<style lang="scss">
@import '../styles/helpers';

.conf-nav {
  position: fixed;
  top: 18px;
  right: 40px;

  &__item {
    cursor: pointer;
    display: inline-block;
    padding: 20px 0;
    font-size: 14px;
    font-weight: 500;
    margin-right: 38px;
    vertical-align: middle;

    &:last-child {
      margin-right: 0;
    }

    img {
      margin-right: 5px;
      vertical-align: middle;
    }
  }

  &__ico-mail { transform: translateY(-2px); }
  &__ico-setup { transform: translateY(-1px); }
}

.conf {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  &-parts {
    background: lightgrey;
    height: 259px;
    position: absolute;
    bottom: 60px;
    left: 0;
    right: 0;
    overflow-x: auto;
    overflow-y: hidden;
  }

  &-parts__list {
    padding: 50px 0 0;
    margin: 0;
    display: flex;
  }

  &-parts__prev, &-parts__next {
    position: fixed;
    left: 0;
    border: 0;
    width: 60px;
    height: 40px;
    background: $c-purple;
    bottom: 170px;
    background-image: url('../assets/arrow-prev.svg');
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;

    &:disabled {
      opacity: 0.6;
    }
  }

  &-parts__next {
    background-image: url('../assets/arrow-next.svg');
    right: 0;
    left: auto;
  }

  &-preview {
    font-size: 12px;
    p { margin: 0;}
  }

  ::-webkit-scrollbar,
  ::-webkit-scrollbar-button ,
  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  &:hover {
    ::-webkit-scrollbar {
      width: 2px;
      height: 2px;
      cursor: pointer;
    }

    ::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }

    ::-webkit-scrollbar-thumb {
      background: grey;
      border: 0px none #ffffff;
      border-radius: 50px;
      &:hover { background: grey; }
      &:active { background: grey; }
    }

    ::-webkit-scrollbar-track {
      background: lightgray;
      border: 0px none #ffffff;
      border-radius: 83px;
      &:hover { background: lightgray; }
      &:active { background: lightgray; }
    }

    ::-webkit-scrollbar-corner { background: transparent; }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Configurator.vue